package com.wintermar.inspection.feature.util.expect_init

import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.theme.AppDimension

actual fun setupLandingContent(
    dimension: AppDimension,
    onLoad: (topPadding: Dp, widthButtonBasedOnText: Boolean) -> Unit
) {
    onLoad(dimension.spacing.space4, true)
}
